
export default {
    props: {
        comments: Array,
        activeCommentId: Number
    },
    watch: {
        activeCommentId: function (newVal, oldVal) {
            this.activeCommentIdLocal = newVal;
        },
    },
    data() {
        return {
            activeCommentIdLocal: this.activeCommentId,
        }
    },
    methods: {
        toggleReplyForm(commentId) {

            if (this.activeCommentIdLocal === commentId) {
                this.activeCommentIdLocal = null;
            } else {
                this.activeCommentIdLocal = commentId;
            }
            // Emit an event to notify the parent component about the changes

            this.$emit("toggle-reply-form", this.activeCommentIdLocal);
        },
    }
};
